import {App, AppStatus, AppStub} from '@web-catalog/types';

import {STARS_COLORS} from '@web-catalog/ui-kit/RatingStar';

import styles from './appStateUtils.module.scss';

export const HIDDEN_APP_TEXT_COLOR = 'neutral-500';

type Arg = App | AppStub | AppStatus;

export const isHiddenApp = (appOrStatus: Arg) => {
  if (typeof appOrStatus === 'object') {
    return appOrStatus.appStatus === 'HIDDEN';
  }

  return appOrStatus === 'HIDDEN';
};

export const getTextColor = (appOrStatus: Arg) =>
  isHiddenApp(appOrStatus) ? HIDDEN_APP_TEXT_COLOR : 'black-100';

export const getSecondaryTextColor = (appOrStatus: Arg) =>
  isHiddenApp(appOrStatus) ? HIDDEN_APP_TEXT_COLOR : 'black-75';

export const getOpacityClass = (appOrStatus: Arg) => {
  if (isHiddenApp(appOrStatus)) {
    return styles.transparent;
  }
};

export const getColorClass = (appOrStatus: Arg) =>
  isHiddenApp(appOrStatus) ? styles.hiddenColor : styles.color;

export const getSecondaryColorClass = (appOrStatus: Arg) =>
  isHiddenApp(appOrStatus) ? styles.hiddenColor : styles.secondaryColor;

export const getBgColorClass = (appOrStatus: Arg) =>
  isHiddenApp(appOrStatus) ? styles.hiddenBgColor : styles.bgColor;

export const getStarsColor = (appOrStatus: Arg) =>
  isHiddenApp(appOrStatus)
    ? STARS_COLORS.SECONDARY_APP_CARD
    : STARS_COLORS.PRIMARY;
